import { ButtonGroup } from "@/components/base/button-group/button-group";
import { FilterToggleItem } from "./filter-toggle-item";
import type { RosterFilterSettings } from "./talent-member-list";

interface PayoutReadinessFiltersProps {
	showPayoutReady: boolean;
	showPayoutNotReady: boolean;
	onShowPayoutReadyChange: (value: boolean) => void;
	onShowPayoutNotReadyChange: (value: boolean) => void;
	onFilterSettingsChange?: (settings: Partial<RosterFilterSettings>) => void;
}

export const PayoutReadinessFilters = ({
	showPayoutReady,
	showPayoutNotReady,
	onShowPayoutReadyChange,
	onShowPayoutNotReadyChange,
	onFilterSettingsChange,
}: PayoutReadinessFiltersProps) => {
	const selectedKeys = [
		...(showPayoutReady ? ["ready"] : []),
		...(showPayoutNotReady ? ["notReady"] : []),
	];

	return (
		<ButtonGroup
			size="sm"
			selectionMode="multiple"
			selectedKeys={selectedKeys}
			onSelectionChange={(keys) => {
				const newReady = keys.has("ready");
				const newNotReady = keys.has("notReady");
				onShowPayoutReadyChange(newReady);
				onShowPayoutNotReadyChange(newNotReady);
				onFilterSettingsChange?.({
					showPayoutReady: newReady,
					showPayoutNotReady: newNotReady,
				});
			}}
		>
			<FilterToggleItem id="ready">Ready</FilterToggleItem>
			<FilterToggleItem id="notReady">Not Ready</FilterToggleItem>
		</ButtonGroup>
	);
};
